<template>
  <div class="step bg-white">
    <div class="form">
      <yxt-form
        ref="refForm"
        label-position="top"
        label-width="80px"
        :model="formData"
        is-need-require
        is-need-tooltip
      >
        <div class="step-subtitle">
          <span class="text color-gray-10">{{$t('pc_subtitle_audit_none')}}</span>
          <yxt-tooltip>
            <yxt-svg
              remote-url=''
              class='color-gray-6 hover-primary-6'
              width='16px'
              height='16px'
              icon-class="question-cirlce-o"
            />
            <div slot="content">
              <span>
                {{$t('pc_tip_audit_none_case')}}<br>
                1.{{$t('pc_tip_audit_none_case_1')}} <br>
                2.{{$t('pc_tip_audit_none_case_2')}} <br>
                3.{{$t('pc_tip_audit_none_case_3')}} <br>
                4.{{$t('pc_tip_audit_none_case_4')}}
              </span>
            </div>
          </yxt-tooltip>
        </div>
        <yxt-form-item class="mb-14">
          <yxt-radio-group v-model="formData.noAuditer">
            <yxt-radio :label="0">{{$t('pc_care_of_audit')}}</yxt-radio>
            <yxt-radio :label="1">{{$t('pc_care_of_sb')}}</yxt-radio>
            <yxt-radio :label="2">{{$t('pc_auto_pass')}}</yxt-radio>
          </yxt-radio-group>
        </yxt-form-item>
        <yxt-form-item
          v-if="formData.noAuditer===1"
          class="bg-gray-1 admins-select"
          prop="user"
        >
          <yxt-select
            :value="getUser"
            multiple
            icon-name="more"
            hidden-option
            value-key="id"
            prop-label="fullname"
            :placeholder="$t('pc_select_placeholder')"
            @visible-change="handleShowSelector"
          >
            <template
              slot='tag'
              slot-scope='{ data }'
            >
              <yxtbiz-user-name :name="data.currentLabel" />
            </template>
          </yxt-select>
        </yxt-form-item>
        <div class="step-subtitle">
          <span class="text color-gray-10">{{$t('pc_title_audit_remind')}}</span>
          <yxt-tooltip>
            <yxt-svg
              remote-url=''
              class='color-gray-6 hover-primary-6'
              width='16px'
              height='16px'
              icon-class="question-cirlce-o"
            />
            <div slot="content">
              <span>
                1. {{$t('pc_title_remind_tip')}}<br>
                2. {{$t('pc_title_remind_tip_2')}}
              </span>
            </div>
          </yxt-tooltip>
        </div>
        <yxt-form-item class="real-rmdr">
          <yxt-checkbox
            v-model="formData.realRmdr"
            :true-label="1"
            :false-label="0"
          >{{$t('pc_real_rmdr')}}</yxt-checkbox>
          <yxt-checkbox
            v-model="formData.rmdrStatus"
            :true-label="1"
            :false-label="0"
          >{{$t('pc_real_rmdr1')}}</yxt-checkbox>
        </yxt-form-item>
        <yxt-form-item
          class="bg-gray-1 real-rmdr-input"
          v-if="formData.rmdrStatus === 1"
          prop="rmdrTime"
        >
          <span class="color-gray-8">{{$t('pc_txt_everday')}}</span>
          <yxt-input-number
            v-model="formData.rmdrTime"
            :min="6"
            :max="23"
            :step="1"
            step-strictly
            @blur="!formData.rmdrTime && (formData.rmdrTime=10)"
          ></yxt-input-number>
          <span class="color-gray-8">{{$t('pc_rmdr_times')}}</span>
        </yxt-form-item>
        <div class="step-subtitle suggest-title">
          <yxt-switch
            v-model="formData.suggest"
            :active-value="1"
            :inactive-value="0"
          ></yxt-switch>
          <span class="text color-gray-10">{{$t('pc_audit_suggest')}}</span>
        </div>
        <!-- agree -->
        <yxt-form-item
          class="suggest-item bg-gray-1"
          v-if="formData.suggest === 1"
        >
          <div class="suggest-radio">
            <span>{{$t('pc_ok_when')}}</span>
            <yxt-radio-group v-model="formData.agree">
              <yxt-radio :label="0">{{$t('pc_txt_optional')}}</yxt-radio>
              <yxt-radio :label="1">{{$t('pc_txt_required')}}</yxt-radio>
            </yxt-radio-group>
          </div>
          <div class="suggest-radio">
            <span>{{$t('pc_reject_when')}}</span>
            <yxt-radio-group v-model="formData.reject">
              <yxt-radio :label="0">{{$t('pc_txt_optional')}}</yxt-radio>
              <yxt-radio :label="1">{{$t('pc_txt_required')}}</yxt-radio>
            </yxt-radio-group>
          </div>
        </yxt-form-item>
        <div class="subtitle">
          <span class="text color-gray-10">其它</span>
        </div>
        <yxt-form-item prop="autoPassAuditSelf">
          <yxt-checkbox
            v-model="formData.autoPassAuditSelf"
            :true-label="1"
            :false-label="0"
          >{{ $t('pc_audit_tips_auth').d('审核人和发起人是同一个人，审核自动通过') }}</yxt-checkbox>
        </yxt-form-item>
      </yxt-form>
    </div>
    <yxt-drawer
      :header-border='false'
      :destroy-on-close="true"
      size="960px"
      :visible.sync="dialogVisible"
    >
      <yxt-single-user
        v-model="user"
        :function-code='functionCode'
        :data-permission-code='dataPermissionCode'
      >
      </yxt-single-user>
      <div slot='footer'>
        <yxt-button
          @click="dialogVisible=false"
          plain
        >{{$t('pc_cancel')}}</yxt-button>
        <yxt-button
          type="primary"
          @click="handleRolesOk"
        >{{$t('pc_ok')}}</yxt-button>
      </div>
    </yxt-drawer>

  </div>
</template>
<script>
import { permissionRole, functionCode } from '../../constants';

export default {
  inject: [ 'functionCode', 'dataPermissionCode' ],
  props: {
    title: String,
    tmplSetting: Object,
    admins: Array
  },
  data() {
    return {
      formData: {
        // 0转交给超管处理
        noAuditer: 0,
        realRmdr: 0,
        rmdrStatus: 0,
        rmdrTime: 10,
        suggest: 1,
        agree: 0,
        reject: 0,
        autoPassAuditSelf: 0,
        user: ''
      },
      user: '',
      rules: {
        user: [
          { required: true, message: this.$t('pc_tip_select_assign'), trigger: 'blur' }
        ]
      },
      dialogVisible: false
    };
  },
  computed: {
    getPermissionRole() {
      return permissionRole;
    },
    getFunctionCode() {
      return functionCode;
    },
    getUser() {
      if (!this.formData.user) return null;
      return [this.formData.user];
    }
  },
  mounted() {
    const v = this.tmplSetting;
    if (v) {
      // eslint-disable-next-line no-unused-vars
      const { user, ...others } = this.formData;
      if (v.selectPer) {
        this.user = this.formData.user = {
          id: v.selectPer,
          fullname: v.selectPerName
        };
      }
      for (const k in others) {
        if (typeof v[k] !== 'undefined') {
          this.formData[k] = v[k];
        }
      }
    }
  },
  methods: {
    getData() {
      const { user, ...others } = this.formData;
      if (user && user.id) {
        others.selectPer = user.id;
        others.selectPerName = user.fullname;
      }
      return others;
    },
    async validateForm() {
      const ret = await new Promise((resolve) => {
        this.$refs.refForm.validate((isOk) => {
          const { user, noAuditer } = this.formData;
          if (noAuditer === 1 && !(user && user.id)) {
            this.$message.error(this.$t('pc_tip_select_assign'));
            resolve(false);
          }
          if (isOk) {
            return resolve(this.getData());
          }
          resolve(isOk);
        });
      });
      return ret;
    },
    handleShowSelector() {
      this.dialogVisible = true;
      this.user = this.formData.user;
    },
    handleRolesOk() {
      if (this.user) {
        this.formData.user = this.user;
        this.dialogVisible = false;
      } else {
        this.$message.error(this.$t('pc_tip_select_assign'));
      }
    }
  }
};
</script>
<style scoped lang="scss">
.step {
  flex: 1;
}

.form {
  display: flex;
  justify-content: center;
  padding-top: 50px;
  .step-subtitle {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 15px;
    .text {
      font-weight: bold;
    }
  }
  .suggest-item {
    margin-top: 8px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .suggest-radio {
    padding-left: 16px;
    padding-right: 16px;
    line-height: 36px;
    > span:first-child {
      margin-right: 12px;
    }
  }
  .real-rmdr {
    margin-bottom: 0;
  }
  .real-rmdr-input {
    padding: 16px;
    margin-bottom: 0px;
  }
  .mb-14 {
    margin-bottom: 14px;
  }
  .suggest-title {
    margin-top: 22px;
  }
  .admins-select {
    padding: 16px;
  }
}
</style>
<style scoped>
.form /deep/ .yxt-form {
  min-width: 506px;
}
.form .yxt-form-item__content{
 line-height: 22px;
}
.real-rmdr-input /deep/ .yxt-input-number {
  margin-left: 8px;
  margin-right: 8px;
}
.admins-select /deep/ .yxt-select {
  width: 474px;
}
.admins-select  /deep/ .yxt-select__tags .yxt-tag__close {
  display: none;
}
/* .suggest-radio /deep/ .yxt-radio__label{
  color: #757575;
} */
</style>
